import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData } from '../types'
import { CmsConverterService } from '../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class WidgetConverter extends CmsConverterService<WidgetData> {
  convertData (source: CmsComponent): WidgetData {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      campaignUrl: formData.st_campaign_url?.value ?? ''
    }
  }
}

export const WIDGET_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, WidgetData>>('WidgetConverter')

export interface WidgetData extends ConvertedComponentData {
  campaignUrl: string;
}
